import { CLUSTER_API } from '../API/BASE_URL';

export const getRoom = async () => {
  const response = await fetch(CLUSTER_API + 'room/', {
    method: 'GET',
  });

  const data = await response.json();
  return data;
};
